import React from "react";
import { cn } from "../lib/utils";

const strengthMap = {
  High: "text-emerald-700 bg-emerald-50 border-emerald-200",
  Favorable: "text-emerald-700 bg-emerald-50 border-emerald-200",
  Medium: "text-amber-700 bg-amber-50 border-amber-200",
  Mixed: "text-amber-700 bg-amber-50 border-amber-200",
  Low: "text-rose-700 bg-rose-50 border-rose-200",
  Unfavorable: "text-rose-700 bg-rose-50 border-rose-200",
  Insufficient: "text-slate-500 bg-slate-50 border-slate-200",
};

export function StrengthBadge({ value, label, testid }) {
  const cls = strengthMap[value] || "text-slate-600 bg-slate-100 border-slate-200";
  return (
    <span data-testid={testid}
      className={cn("inline-flex items-center gap-1.5 font-mono text-xs font-medium px-2.5 py-1 rounded border", cls)}>
      {label && <span className="text-[10px] uppercase tracking-wider opacity-70">{label}</span>}
      {value}
    </span>
  );
}

const typeMap = {
  fact: { label: "FACT", cls: "text-slate-700 bg-slate-100 border border-slate-200" },
  inference: { label: "AI INFERENCE", cls: "text-blue-700 bg-blue-50 border border-blue-200" },
  unknown: { label: "UNKNOWN", cls: "text-slate-500 bg-transparent border border-dashed border-slate-300" },
};

export function EvidenceTag({ type }) {
  const t = typeMap[type] || typeMap.unknown;
  return (
    <span className={cn("font-mono text-[10px] font-semibold px-1.5 py-0.5 rounded tracking-wide", t.cls)}>
      {t.label}
    </span>
  );
}

const outcomeMap = {
  positive: "text-emerald-700 bg-emerald-50 border-emerald-200",
  negative: "text-rose-700 bg-rose-50 border-rose-200",
  mixed: "text-amber-700 bg-amber-50 border-amber-200",
  unclear: "text-slate-500 bg-slate-50 border-slate-200",
};

export function OutcomeBadge({ value }) {
  const cls = outcomeMap[value] || outcomeMap.unclear;
  return (
    <span className={cn("font-mono text-xs font-medium px-2 py-1 rounded border capitalize", cls)}>
      {value}
    </span>
  );
}
